import ValutaFilter from '@eika-infrastruktur/ui-valuta-filter';
import React from 'react';
import { Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import spareUtregning from '../utils/spareutregning';

interface SpareGrafProps {
    sparingPerMnd: number;
    oppspart: number;
    fondsRenteProsent: number;
    bankRenteProsent: number;
    inflasjonProsent: number;
    antallAar: number;
    fondLabel: string;
    bankLabel: string;
    millionForkortelse: string;
    milliardForkortelse: string;
}

const SpareGraf = (props: SpareGrafProps) => {
    const startAar = new Date().getUTCFullYear();

    const generateTickText = (tick: number): string => {
        if (tick < 1000000) return ValutaFilter(tick, ' ', 0);
        if (tick < 1000000000) return `${(tick / 1000000).toString().replace('.', ',')} ${props.millionForkortelse}`;
        return `${(tick / 1000000000).toString().replace('.', ',')} ${props.milliardForkortelse}`;
    };

    const genererGrafData = (
        fondKey: string,
        bankKey: string,
        startAar: number,
        antallAar: number,
        oppspart: number,
        spareUtregning: (
            antallAar: number,
            sparingPerMnd: number,
            renteProsent: number,
            inflasjonProsent: number,
            oppspart: number
        ) => number
    ) => {
        return [...Array(antallAar + 1)].map((_, i) => ({
            name: `${startAar + i}`,
            [fondKey]: spareUtregning(
                i,
                props.sparingPerMnd,
                props.fondsRenteProsent,
                props.inflasjonProsent,
                oppspart
            ),
            [bankKey]: spareUtregning(i, props.sparingPerMnd, props.bankRenteProsent, props.inflasjonProsent, oppspart)
        }));
    };

    const data = genererGrafData(
        props.fondLabel,
        props.bankLabel,
        startAar,
        props.antallAar,
        props.oppspart,
        spareUtregning
    );

    return (
        <div className="charts-container">
            <ResponsiveContainer height={230}>
                <LineChart data={data} margin={{ right: -40 }}>
                    <XAxis
                        dataKey="name"
                        axisLine={false}
                        tickLine={false}
                        interval="preserveStartEnd"
                        ticks={[startAar, props.antallAar + startAar]}
                    />
                    // @ts-ignore textAnchor is missing from props-interface
                    <YAxis
                        dataKey={props.fondLabel}
                        orientation="right"
                        axisLine={false}
                        tickLine={false}
                        width={100}
                        interval="preserveStartEnd"
                        tickFormatter={generateTickText}
                        textAnchor="end"
                        dx={50}
                    />
                    // @ts-ignore boxWidth is missing from props-interface
                    <Tooltip formatter={value => `${ValutaFilter(value, ' ', 0)} kr`} separator=": " boxWidth={500} />
                    <Legend layout="vertical" iconType="circle" iconSize={20} />
                    <Line
                        type="monotone"
                        dataKey={props.fondLabel}
                        dot={false}
                        stroke="#84bd00"
                        strokeWidth={2}
                        strokeLinecap="round"
                    />
                    <Line
                        type="monotone"
                        dataKey={props.bankLabel}
                        dot={false}
                        stroke="#007fad"
                        strokeWidth={2}
                        strokeLinecap="round"
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default SpareGraf;
